import { tz as e } from "../../node_modules/@date-fns/tz/tz/index.js";
import "../../node_modules/@date-fns/tz/index.js";
import t from "../../node_modules/date-fns/startOfWeek.js";
import n from "../../node_modules/date-fns/startOfDay.js";
import r from "../../node_modules/date-fns/endOfMonth.js";
import i from "../../node_modules/date-fns/startOfMonth.js";
import a from "../../node_modules/date-fns/endOfYear.js";
import o from "../../node_modules/date-fns/startOfYear.js";
import s from "../../node_modules/date-fns/subDays.js";
import c from "../../node_modules/date-fns/subMonths.js";
import l from "../../node_modules/date-fns/subYears.js";
//#region lib/components/DatePicker/presets.ts
var u = "custom";
function d(t, r) {
	return n(t, r ? { in: e(r) } : void 0);
}
function f(e) {
	return d(Date.now(), e);
}
var p = 2e3, m = [
	{
		id: "today",
		label: "Today",
		getDate: (e) => f(e)
	},
	{
		id: "yesterday",
		label: "Yesterday",
		getDate: (e) => s(f(e), 1)
	},
	{
		id: "start-of-week",
		label: "Start of Week",
		getDate: (e) => t(f(e))
	},
	{
		id: "start-of-month",
		label: "Start of Month",
		getDate: (e) => i(f(e))
	},
	{
		id: "start-of-year",
		label: "Start of Year",
		getDate: (e) => o(f(e))
	},
	{
		id: u,
		label: "Custom",
		getDate: (e) => f(e)
	}
], h = [
	{
		id: "today",
		label: "Today",
		getRange: (e) => {
			let t = f(e);
			return {
				from: t,
				to: t
			};
		}
	},
	{
		id: "yesterday",
		label: "Yesterday",
		getRange: (e) => {
			let t = s(f(e), 1);
			return {
				from: t,
				to: t
			};
		}
	},
	{
		id: "last-7-days",
		label: "Last 7 Days",
		getRange: (e) => {
			let t = f(e);
			return {
				from: s(t, 6),
				to: t
			};
		}
	},
	{
		id: "last-30-days",
		label: "Last 30 Days",
		getRange: (e) => {
			let t = f(e);
			return {
				from: s(t, 29),
				to: t
			};
		}
	},
	{
		id: "last-month",
		label: "Last Month",
		getRange: (e) => {
			let t = c(f(e), 1);
			return {
				from: i(t),
				to: r(t)
			};
		}
	},
	{
		id: "last-year",
		label: "Last Year",
		getRange: (e) => {
			let t = l(f(e), 1);
			return {
				from: o(t),
				to: a(t)
			};
		}
	},
	{
		id: "all-time",
		label: "All Time",
		getRange: (e, t) => ({
			from: t?.minDate ? d(t.minDate, e) : n(new Date(p, 0, 1)),
			to: f(e)
		})
	},
	{
		id: u,
		label: "Custom",
		getRange: () => ({})
	}
];
//#endregion
export { u as CUSTOM_PRESET_ID, m as datePickerPresetsDefault, h as dateRangePickerPresetsDefault, d as zonedStartOfDay, f as zonedStartOfToday };
